import React, { useState } from 'react';
import styles from './Examples.module.css';
import example1 from '../../../src/img/chek-001.jpg';
import example2 from '../../../src/img/chek-002.jpg';
import example3 from '../../../src/img/chek-003.jpg';
import example1Large from '../../../src/img/chek-001.jpg';
import example2Large from '../../../src/img/chek-002.jpg';
import example3Large from '../../../src/img/chek-003.jpg';

const Examples = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const examples = [
    { id: 1, thumb: example1, large: example1Large, alt: "Пример гостиничного чека 1" },
    { id: 2, thumb: example2, large: example2Large, alt: "Пример гостиничного чека 2" },
    { id: 3, thumb: example3, large: example3Large, alt: "Пример гостиничного чека 3" }
  ];

  const openImage = (image) => {
    setSelectedImage(image);
  };

  const closeImage = () => {
    setSelectedImage(null);
  };

  return (
    <section id="examples" className={styles.examples}>
      <div className="container">
        <div className={styles.examplesHeader}>
          <h2 className={styles.sectionTitle}>Примеры оформленных чеков</h2>
        </div>
        
        <div className={styles.examplesGrid}>
          {examples.map((example) => (
            <div key={example.id} className={styles.exampleItem}>
              <div 
                className={styles.exampleImage}
                onClick={() => openImage(example)}
              >
                <img src={example.thumb} alt={example.alt} />
                <div className={styles.imageOverlay}>
                  <span className={styles.zoomIcon}>🔍</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Modal */}
      {selectedImage && (
        <div className={styles.modal} onClick={closeImage}>
          <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <button className={styles.closeButton} onClick={closeImage}>×</button>
            <img src={selectedImage.large} alt={selectedImage.alt} />
          </div>
        </div>
      )}
    </section>
  );
};

export default Examples;